import { IncludeSSRFeatureFlagsConfig } from '../../types';

const retrieveFeatureFlags = async getFeatureFlags => {
  try {
    const featureFlags = await getFeatureFlags();

    if (featureFlags) {
      return {
        'ssr:featureFlags': featureFlags
      };
    }
  } catch (e) {}

  return null;
};

export const ssrFeatureFlags = async (config, _data, globalConfig) => {
  var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;

  // no config or missing
  if (!((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags)) {
    return null;
  }

  const includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || IncludeSSRFeatureFlagsConfig.WHEN_FMP;

  if (includeFeatureFlags === IncludeSSRFeatureFlagsConfig.WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === IncludeSSRFeatureFlagsConfig.WHEN_FMP) {
    return await retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
  }

  return null;
};